
define('text!templates/modules/calendar/nutrition/nutrient/list/nutrient-list-item.html',[],function () { return '<div class="macro-name ucolfix">{{translatedName}}</div>\n<div class="macro-bar ucolfix">{{#bar}}<span class="bar"><span class="bar-color bar-{{status}}" style="width:{{percent}}%"></span></span>\n{{/bar}}</div>\n<div class="macro-unit ucolfix">{{roundedValue}} {{unit}}</div>\n';});

